import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ScrollSaveService {
    private positions = new Map<string, number>();

    save(key: string, position: number) {
        this.positions.set(key, position);
    }

    get(key: string): number {
        return this.positions.get(key) ?? 0;
    }
}
